/**
 * Generate a UUID v4.
 *
 * Uses `crypto.randomUUID()` when available and falls back to a client-side
 * RFC4122-compatible implementation for older environments.
 *
 * @returns {string}
 */
export const generateUUID = () =>
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
              const random = (Math.random() * 16) | 0;
              return (char === 'x' ? random : (random & 0x3) | 0x8).toString(16);
          });
